import { render, staticRenderFns } from "./product-serial.vue?vue&type=template&id=3805b97d&"
import script from "./product-serial.vue?vue&type=script&lang=js&"
export * from "./product-serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports